import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'

export const filterToolBySearch = (tool: AgentTool, search: string): boolean => {
  const searchLower = search.toLowerCase()
  const matchesName = tool.name.toLowerCase().includes(searchLower)
  const matchesDescription = tool.description.toLowerCase().includes(searchLower)
  const matchesCategory = tool.category.toLowerCase().includes(searchLower)
  const matchesId = tool.id.toLowerCase().includes(searchLower)
  return matchesName || matchesDescription || matchesCategory || matchesId
}

export const getFilteredSelectedCount = (
  selectedIdList: string[],
  filteredIdList: string[]
): number => {
  const filteredIdSet = new Set(filteredIdList)
  return selectedIdList.filter((id) => filteredIdSet.has(id)).length
}

export const createToolFilter = (
  toolList: AgentTool[]
): ((itemValue: string, search: string) => number) => {
  return (itemValue: string, search: string): number => {
    const tool = toolList.find((t) => t.id === itemValue)
    if (!tool) return 0
    return filterToolBySearch(tool, search) ? 1 : 0
  }
}
